<template>
<div class="hello">
</div>
</template>

<script>
export default {
    name: 'authLogin',
    components: {
    },
    data: () => ({
        email:""
    }),
    mounted() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.email = this.$route.query.email;
        this.type = this.$route.query.type;
        // alert(this.type);
        if(this.type == 'app'){
            sessionStorage.setItem("type","app");
        }else{
            sessionStorage.setItem("type","web");
        }
        this.authLogin();
    },
    methods: {
        authLogin:function(){
            var params = {
                email:this.email
            }
            var me = this;
            this.axios.post(this.$store.state.host + "/rest/common/authLoginPlatform", params).then(function (res) {
                // console.log(res);
                if(res.data.err == 0){
                    localStorage.setItem("accessToken",res.data.token);
                    localStorage.setItem("accessKey",res.data.accessKey);
                    console.log(res.data.accessKey);
                    localStorage.setItem("uidx",res.data.uidx);
                    localStorage.setItem("kname",res.data.kname);
                    localStorage.setItem("ename",res.data.ename);
                    me.$router.push("/intro")
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
</style>
